import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { faPause } from '@fortawesome/pro-light-svg-icons/faPause';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { useCampaignActions } from '../hooks/useCampaignActions';
import { useOutreachPlan } from '../hooks/useOutreachPlan';
import { liveMessages as messages } from './liveMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the live screens; each part uses its own slice of it */
import styles from './Live.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SearchFooterProps {
  accountId: number;
  campaignUuid: string;
  mailbox: string | null;
  canPause: boolean;
}

/** "Nothing goes out yet ... from <mailbox>" and Pause (design t1). */
const SearchFooterComponent: React.FC<SearchFooterProps> = ({ accountId, campaignUuid, mailbox, canPause }) => {
  const intl = useIntl();
  const plan = useOutreachPlan();
  const { pauseCampaign, isChangingState } = useCampaignActions(accountId);
  const pause = useCallback(() => {
    pauseCampaign(campaignUuid).catch(console.error);
  }, [campaignUuid, pauseCampaign]);
  return (
    <div className={styles.footer} data-testid="search-footer">
      <span className="flex-grow-1">
        {mailbox === null
          ? intl.formatMessage(messages.nothingYetNoMailbox)
          : intl.formatMessage(messages.nothingYet, { mailbox: <b key="mailbox">{mailbox}</b> })}
      </span>
      {canPause && (
        <SMLButton
          size="sm"
          outline
          omitCap
          leftIcon={faPause}
          onClick={pause}
          isLoading={isChangingState}
          disabled={plan.isDemo || isChangingState}
          testID="search-pause"
        >
          {intl.formatMessage(messages.pause)}
        </SMLButton>
      )}
    </div>
  );
};

export const SearchFooter = TypedMemo(SearchFooterComponent);
